module.exports = __webpack_public_path__ + "static/news2-pic2-ee8b48ac314fb132b88564aeecaa5781.jpg";